
import { Vue } from "vue-class-component";
export default class Footer extends Vue {
    clickLogo() {
        window.scrollTo(0,0)
        this.$router.push("/");
    }
}
